import { get, lowerCase, merge, orderBy } from 'lodash'

const _ALL = typeof Symbol === 'function' ? Symbol('_ALL') : '_ALL'
const _FILTERS = typeof Symbol === 'function' ? Symbol('_FILTERS') : '_FILTERS'

export class RegionFactory {
  constructor () {
    this[_ALL] = get(require('@/data/regions'), 'regions', [])
    this[_FILTERS] = []
  }
  get all () {
    return this[_ALL]
  }
  get ordered () {
    return orderBy(this[_ALL], region => lowerCase(region.region))
  }
  get appliedFilters () {
    return merge(...this[_FILTERS])
  }
  get regionIdField () {
    return 'region_id'
  }
  get categoryField () {
    return 'category'
  }
  get countryField () {
    return 'country_iso_3'
  }
  // Chainable methods: they must all return `this`
  filterByRegion (value) {
    this[_FILTERS].push({ [this.regionIdField]: value })
    return this
  }
  static create () {
    return new RegionFactory()
  }
}

export default new RegionFactory()
